export default __webpack_public_path__ + "static/media/2.b7c2439f.svg";